import {
  Component,
  OnInit,
  ViewChild,
  OnDestroy,
  AfterViewInit,
  ElementRef,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  PopulationReport,
  PopulationReportSearch,
  PopPipelineStatus,
} from '../../models/PopulationReport';
import { GradingValues } from '../../models/PopulationReport';
import {
  FormControl,
  FormGroup,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { PopReportsService } from '../../services/pop-reports.service';
import { ErrorService } from '../../../common/services/error.service';
import {
  GroupSettingsModel,
  ToolbarItems,
  FilterSettingsModel,
  IFilter,
} from '@syncfusion/ej2-grids';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { SubSink } from 'subsink';
import { Title } from '@angular/platform-browser';
import { finalize } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'pop-reports',
    templateUrl: './pop-reports.component.html',
    styleUrls: ['./pop-reports.component.css'],
    standalone: false
})
export class PopReportsComponent implements OnInit, AfterViewInit, OnDestroy {
  public AllPopulationReport!: PopulationReport[];
  public AllPopulationReportSearch!: PopulationReportSearch[];
  public PopPipelineStatus!: PopPipelineStatus[];
  yearsInBusiness = new Date().getFullYear() - 1998;

  private subs = new SubSink();
  public groupOptions!: GroupSettingsModel;
  public toolbarOptions!: ToolbarItems[];
  @ViewChild('grid2')
  public grid!: GridComponent;
  public filterOptions!: FilterSettingsModel;
  public filter!: IFilter;
  public sortOptions!: Object;
  grades = new Array<any>();
  setName: any;
  siteKey: any = environment.captcha.siteKey;
  show: boolean = false;
  isSearching: boolean = false;
  PopLineheck: boolean = true;
  cansearch: boolean = false;
  PopReportSubmitted: boolean = false;

  public searchPopReportForm!: FormGroup;
  constructor(
    private router: Router,
    private popReportsService: PopReportsService,
    private formBuilder: FormBuilder,
    private titleService: Title
  ) { }
  private recaptchaWidgetId: number | null = null;
  private recaptchaSiteKey = environment.captcha.siteKey;
  captchaError = false;
  private recaptchaToken: string | null = null;


  ngOnInit(): void {
    this.titleService.setTitle('Pop Report');
    this.searchPopReportForm = this.formBuilder.group({
      popReportSearch: [
        '',
        Validators.compose([Validators.minLength(8), Validators.required]),
      ],
    });
  }

  ngAfterViewInit() {
    this.initializeRecaptchaEnterprise();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
    if (this.recaptchaWidgetId !== null && window.grecaptcha?.enterprise) {
      try {
        window.grecaptcha.enterprise.reset(this.recaptchaWidgetId);
      } catch (e) {
        console.error('Error resetting reCAPTCHA:', e);
      }
    }
  }

  private resetRecaptcha() {
    if (this.recaptchaWidgetId !== null && window.grecaptcha?.enterprise) {
      try {
        const container = document.getElementById('recaptcha-enterprise-container');
        if (container) {
          container.style.opacity = '0.5';
        }
        window.grecaptcha.enterprise.reset(this.recaptchaWidgetId);
        this.recaptchaToken = null;
        setTimeout(() => {
          if (container) {
            container.style.opacity = '1';
          }
        }, 300);

        console.log('✅ reCAPTCHA reset successfully');
      } catch (error) {
        console.error('❌ Error resetting reCAPTCHA:', error);
      }
    }
  }

  private initializeRecaptchaEnterprise() {
    if (typeof window.grecaptcha === 'undefined' ||
      typeof window.grecaptcha.enterprise === 'undefined') {
      console.log('Waiting for reCAPTCHA Enterprise to load...');
      setTimeout(() => this.initializeRecaptchaEnterprise(), 100);
      return;
    }

    window.grecaptcha.enterprise.ready(() => {
      try {
        this.recaptchaWidgetId = window.grecaptcha.enterprise.render('recaptcha-enterprise-container', {
          sitekey: this.recaptchaSiteKey,
          action: 'CHECK_POPREPORT',
          callback: (token: string) => {
            this.recaptchaToken = token;
            this.captchaError = false;
            console.log('✅ reCAPTCHA Enterprise completed');
          },
          'expired-callback': () => {
            this.recaptchaToken = null;
            this.captchaError = false;
            console.log('❌ reCAPTCHA Enterprise expired');
          },
          'error-callback': () => {
            this.recaptchaToken = null;
            this.captchaError = false;
            console.error('❌ reCAPTCHA Enterprise error');
          },
          theme: 'dark',
          size: 'normal'
        });
        console.log('✅ reCAPTCHA Enterprise widget initialized');
      } catch (error) {
        console.error('Error rendering reCAPTCHA Enterprise:', error);
      }
    });
  }

  GetPopPipelineStatus() {
    this.popReportsService.getPopPipelineStatus().subscribe((response) => {
      this.PopPipelineStatus = response;
      if (this.PopPipelineStatus.length >= 1) {
        this.PopLineheck = true;
      } else {
        this.PopLineheck = false;
      }
    });
  }
  getPopReportByT205() {
    if (!this.recaptchaToken) {
      this.captchaError = true;
      return;
    }
    this.isSearching = true;
    this.popReportsService
      .getPopReportBySetName('t205', this.recaptchaToken)
      .pipe(finalize(() => (this.isSearching = false))).subscribe({
        next: (response: any) => {
          this.resetRecaptcha();
          this.AllPopulationReportSearch = response;
          this.isSearching = false;
          this.show = true;
          this.filterOptions = { type: 'Menu' };
          this.filter = { type: 'CheckBox' };
          this.sortOptions = {
            columns: [
              { field: 'cardSet', direction: 'Ascending' },
              { field: 'sport', direction: 'Ascending' },
            ],
          };
        },
        error: (err: any) => {
          this.resetRecaptcha();
        }
      });
  }
  getPopReportByT206() {
    if (!this.recaptchaToken) {
      this.captchaError = true;
      return;
    }
    this.isSearching = true;
    this.popReportsService
      .getPopReportBySetName('t206', this.recaptchaToken)
      .pipe(finalize(() => (this.isSearching = false))).subscribe({
        next: (response: any) => {
          this.resetRecaptcha();
          this.AllPopulationReportSearch = response;
          this.isSearching = false;
          this.show = true;
          this.filterOptions = { type: 'Menu' };
          this.filter = { type: 'CheckBox' };
          this.sortOptions = {
            columns: [
              { field: 'cardSet', direction: 'Ascending' },
              { field: 'sport', direction: 'Ascending' },
            ],
          };
        },
        error: (err: any) => {
          this.resetRecaptcha();
        }
      });
  }

  getPopReportByCardSet() {
    this.show = false;
    this.PopReportSubmitted = true;
    if (this.searchPopReportForm.invalid) {
      return;
    }

    if (!this.recaptchaToken) {
      this.captchaError = true;
      return;
    }

    var cardSet = this.searchPopReportForm.get('popReportSearch')?.value;
    this.LoadData(cardSet, this.recaptchaToken);
  }
  getPopReportByCardSetEnter() {

    this.show = false;
    this.PopReportSubmitted = true;

    if (this.searchPopReportForm.invalid) {
      return;
    }

    if (!this.recaptchaToken) {
      this.captchaError = true;
      return;
    }

    var cardSet = this.searchPopReportForm.get('popReportSearch')?.value;
    this.LoadData(cardSet, this.recaptchaToken);

  }

  LoadData(cardSet: any, recaptchaToken: any) {
    this.isSearching = true;
    this.PopReportSubmitted = false;
    this.popReportsService.getPopPipelineStatus().pipe(finalize(() => { })).subscribe({
      next: (response: any) => {
        this.PopPipelineStatus = response;
        if (this.PopPipelineStatus.length >= 1) {
          this.PopLineheck = true;
          this.popReportsService.getPopReportBySetName(cardSet, recaptchaToken)
            .pipe(finalize(() => (this.isSearching = false))).subscribe({
              next: (response: any) => {
                this.resetRecaptcha();
                this.AllPopulationReportSearch = response;
                this.isSearching = false;
                this.show = true;
                this.filterOptions = { type: 'Menu' };
                this.filter = { type: 'CheckBox' };
                this.sortOptions = {
                  columns: [
                    { field: 'cardSet', direction: 'Ascending' },
                    { field: 'sport', direction: 'Ascending' },
                  ],
                };
              },
              error: (err: any) => {
                this.resetRecaptcha();
              }
            });
        } else {
          this.PopLineheck = false;
          this.isSearching = false;
          this.AllPopulationReportSearch.length = 0;
        }
      },
      error: (err: any) => {
      }
    });
  }

  click(cardSet: any, sport: any) {
    this.router.navigate(['/pop-report/result/', cardSet, sport]);
  }
}
